import React from 'react';

export function useEffectPostMount(func: React.EffectCallback, deps?: React.DependencyList | undefined) {
  const didMount = React.useRef(false);
  React.useEffect(() => {
    if (didMount.current) return func();
    else didMount.current = true;
  }, deps);
}
